module.exports = __webpack_public_path__ + "static/media/percentage.48335d7a.svg";